<coin-v2-dialog-frame [header]="'general.add' | translate">
  <div class="body-container">
    <div class="input-container">
      <coin-v2-text-input
        placeholder="..."
        matFormFieldClass="shadow"
        icon="edit"
        [label]="data?.label || 'Title'"
        [(ngModel)]="plan.title" />
      @if (data?.showDescription) {
        <coin-v2-text-area
          class="admin-form-field-outline admin-form-field-outline--shadow admin-form-field-outline--dynamic-height"
          [ngModelOptions]="{ standalone: true }"
          [label]="data.descriptionLabel ? (data.descriptionLabel | translate) : ('general.description' | translate)"
          [placeholder]="'general.enter-description' | translate"
          [(ngModel)]="plan.description" />
      }
      @if (showDisplayName) {
        <coin-v2-text-input
          placeholder="..."
          matFormFieldClass="shadow"
          icon="edit"
          [label]="'Display Name'"
          [(ngModel)]="plan.displayName" />
      }
    </div>
  </div>

  <coin-v2-dialog-footer color="white">
    <coin-v2-button
      type="outline"
      icon="close"
      iconPos="right"
      [text]="'general.btnCancel' | translate"
      (click)="cancel()"></coin-v2-button>
    <coin-v2-button
      type="primary"
      icon="add"
      iconPos="right"
      [text]="'general.add' | translate"
      (click)="addPlan()"></coin-v2-button>
  </coin-v2-dialog-footer>
</coin-v2-dialog-frame>
